import type { SeriesPlaylist, TVShowsPlaylist } from '@setplex/tria-api'
import type { TFunction } from '~/core/i18n'
import type { ICWatching } from '../continue-watching'

import { formatSeason, formatSeasonEpisode } from '../lib'

export const playlistFormatter = ({
  playlist,
  t,
}: {
  playlist: TVShowsPlaylist
  t: TFunction
}) => {
  if (playlist?.seasonsWithEpisodes) {
    return {
      ...playlist,
      seasonsWithEpisodes: playlist?.seasonsWithEpisodes?.map((season) =>
        formatSeason({ season, t })
      ),
    }
  }

  if (playlist?.episodes) {
    return {
      ...playlist,
      episodes: playlist?.episodes?.map((episode) =>
        formatSeasonEpisode({ episode, t })
      ),
    }
  }

  return playlist
}

// get cw data for current episode from series playlist
export const formatPlaylistToCW = (
  playlist: SeriesPlaylist | null,
  stoppedTime: number | undefined = 0
): ICWatching | null => {
  if (!playlist?.currentTvShow || !playlist.currentEpisode?.id) return null

  return {
    tvShow: {
      id: playlist.currentTvShow.id,
      isWithSeason: playlist.currentTvShow.isWithSeason ?? false,
    },
    seasonId: playlist.currentSeason?.id ?? null,
    episodeId: playlist.currentEpisode.id,
    stoppedTime,
    lengthMillis: playlist.currentEpisode.duration ?? 0,
  }
}
